module.exports = __webpack_public_path__ + "fonts/OpenSans-Italic.052b69c9.woff";